import { InflatedListItemProduct } from './ListTypes'
import lodash from 'lodash'
import { Cross } from '../characters'
import { getInterfaceDisplayName } from '../products/productUtils'
import { InterfaceProduct, MechProduct } from '../types/productTypes'

export function getListInterfaceDisplayName(interfaceProduct: InterfaceProduct, mechProduct: MechProduct | null): string {
  const name = getInterfaceDisplayName(interfaceProduct, mechProduct)
  return interfaceProduct.category === 'Switches' ? `${name} Switch` : name
}

export function getListItemInterfacesDisplayText(configuredProduct: InflatedListItemProduct): string[] | null {
  const aggregatedInterfaces = lodash.groupBy(configuredProduct.configuredButtons, it => `${it.interfaceProduct.itemNo} ${it.mechProduct?.itemNo ?? ''}`)
  const interfaceKeys = Object.keys(aggregatedInterfaces)

  const interfaces = interfaceKeys.map(key => {
    const item = aggregatedInterfaces[key][0]
    const label = getListInterfaceDisplayName(item.interfaceProduct, item.mechProduct)
    const count = aggregatedInterfaces[key].length

    if (count === 1) {
      return label
    }

    return `${count} ${Cross} ${label}`
  })

  return interfaces.length > 0 ? interfaces : null
}
